var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expense__actions flex items-center flex-wrap justify-between p-4 border border-r-0 border-l-0 border-solid border-white"},[_c('div',{staticClass:"flex w-1/3 justify-start content content-center"},[_vm._t("left")],2),_c('div',{staticClass:"flex w-1/3 justify-end content content-center"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }